import { render, staticRenderFns } from "./AppB.vue?vue&type=template&id=c5b08026&"
import script from "./AppB.vue?vue&type=script&lang=js&"
export * from "./AppB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports